"use client";

import React, { CSSProperties, useEffect, useRef } from "react";
import styled from "styled-components";

interface HTMLRenderProps {
  html: string | null | undefined;
  className?: string;
  style?: CSSProperties;
}

const HTMLRender: React.FC<HTMLRenderProps> = ({ html, className, style }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!html || !wrapperRef.current) return;
    // Execute scripts after the HTML is rendered
    const scripts = wrapperRef.current.querySelectorAll("script");
    const createdScripts: HTMLScriptElement[] = [];

    scripts.forEach((oldScript) => {
      const newScript = document.createElement("script");
      // Copy all attributes
      Array.from(oldScript.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });
      // Copy script content
      if (oldScript.innerHTML) {
        newScript.innerHTML = oldScript.innerHTML;
      }
      // Replace the old script with the new one to ensure execution
      oldScript.parentNode?.replaceChild(newScript, oldScript);
      createdScripts.push(newScript);
    });

    return () => {
      // Clean up created scripts when component unmounts or html changes
      createdScripts.forEach((script) => {
        script.parentNode?.removeChild(script);
      });
    };
  }, [html]);

  if (!html) return null;

  return (
    <Wrapper
      ref={wrapperRef}
      className={className}
      dangerouslySetInnerHTML={{ __html: html }}
      style={style}
    />
  );
};

export default HTMLRender;

const Wrapper = styled.div`
  overflow: auto;
`;
